module.exports = __webpack_public_path__ + "static/img/home-about.7257bf32.png";